import React from 'react';
import { motion } from 'framer-motion';

export default function TermsOfService() {
  return (
    <div className="bg-gray-50 min-h-screen py-16 px-4 sm:px-6 lg:px-8">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm p-8 sm:p-12 text-gray-800"
      >
        <h1 className="text-4xl font-extrabold text-gray-900 mb-8 font-display">Terms of Service</h1>
        
        <div className="space-y-6 text-sm sm:text-base leading-relaxed">
          <p className="text-gray-500 italic">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
          <p>
            By accessing or using Generic Ideas, you agree to be bound by these Terms of Service. 
            If you disagree with any part of these terms, you may not access our services.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Online Store Terms</h2>
          <p>
            By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence.
            You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Accuracy of Information</h2>
          <p>
            We are not responsible if information made available on this site is not accurate, complete or current. 
            The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Modifications to the Service and Prices</h2>
          <p>
            Prices for our products are subject to change without notice. We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Payment via Stripe</h2>
          <p>
            We use Stripe as a third-party payment processor. By purchasing from Generic Ideas, you agree to Stripe's payment terms. We do not store your credit card information directly. 
            Stripe securely processes transactions and is certified to PCI Service Provider Level 1.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Limitation of Liability</h2>
          <p>
            In no case shall Generic Ideas, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Contact Information</h2>
          <p>
            Questions about the Terms of Service should be sent to us at info@genericideas.com.
          </p>
        </div>
      </motion.div>
    </div>
  );
}
